import { Endpoint } from "../config";

export type AuthEndpointType =
  "login"
  | "logout"
  | "refreshToken"
  | "forgotPassword"
  | "resetPassword"
  | "verifyOtp"
  | "resendOtp"
  | "changePassword"
  | "createPassword"
  | "getUserPermissions";

export const authEndpoints: Record<AuthEndpointType, Endpoint> = {
  login: {
    url: "login/",
  },
  logout: {
    url: "logout/",
  },
  refreshToken: {
    url: "refresh-token/",
  },
  forgotPassword: {
    url: "forgot-password/",
  },
  resetPassword: {
    url: "change-password/",
  },
  verifyOtp: {
    url: "verify-otp/",
  },
  resendOtp: {
    url: "resend-otp/",
  },
  changePassword: {
    url: "change-password/",
  },
  getUserPermissions: {
    url: "get-permission/",
  },
  createPassword: {
    url: "reset-password/",
  },
};
